"use client"
export const imageLoader = ({ src, width, quality }: any) => {
  const format = typeof window !== 'undefined' && supportsAvif() ? 'avif' : 'webp';
  const dpr = typeof window !== 'undefined' ? window.devicePixelRatio : 1;
  const adjustedWidth = width * dpr;
  const url = `${src}?w=${adjustedWidth}&q=${quality || 75}&fm=${format}`;
  return url;
};


function supportsAvif() {
  if (typeof window === 'undefined') {
    // Server-side, return false by default
    return false;
  }
  const canvas = document.createElement('canvas');
  return canvas.toDataURL('image/avif').indexOf('data:image/avif') === 0;
}
